/**
 * Satisfaction Guarantee JavaScript
 * Handles scrolling functionality
 */

class SatisfactionGuarantee {
  constructor() {
    this.init();
  }

  init() {
    // Add event listeners when DOM is loaded
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () =>
        this.attachEventListeners()
      );
    } else {
      this.attachEventListeners();
    }
  }

  attachEventListeners() {
    // Find all CTA buttons in the guarantee section
    const ctaButtons = document.querySelectorAll(".guarantee-section__cta");

    // Add click event listener to each button
    ctaButtons.forEach((button) => {
      button.addEventListener("click", this.scrollToProduct);
    });
  }

  scrollToProduct(event) {
    // Florelle: follow the button link when one is set (e.g. on the homepage)
    const flHref = event.currentTarget && event.currentTarget.getAttribute("href");
    if (flHref && flHref !== "#") return;
    event.preventDefault();

    // Florelle: go straight to the order area of the buy box (bundle picker / add to cart)
    const flMain = document.querySelector('.shopify-section[id$="__main"]');
    const flTarget = flMain && (
      flMain.querySelector(".quantity-break-container") ||
      flMain.querySelector('form[action*="/cart/add"]') ||
      flMain
    );
    if (flTarget) {
      const header = document.querySelector("sticky-header, .header-wrapper, .shopify-section-header-sticky");
      const offset = header ? header.getBoundingClientRect().height : 0;
      window.scrollTo({
        top: flTarget.getBoundingClientRect().top + window.pageYOffset - offset - 16,
        behavior: "smooth",
      });
      return false;
    }

    // Find the first product section on the page using various selectors
    const productSection = document.querySelector(
      ".shopify-section .product, " +
        '.shopify-section [data-section-type="product"], ' +
        "main#MainContent .product-template, " +
        "main#MainContent .product, " +
        "#ProductSection, " +
        "#shopify-section-product-template, " +
        ".product-section"
    );

    if (productSection) {
      // Scroll to the product section
      productSection.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else {
      // Fallback: just scroll to top if product section not found
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }

    return false;
  }
}

// Initialize the class
document.addEventListener("DOMContentLoaded", function () {
  new SatisfactionGuarantee();
});
